import { Children, useEffect, useState, useMemo, cloneElement } from "react";
import { getPricingData } from "../lib/utils/pricing/promo-util";
import { node } from "prop-types";

/**
 * displays the components based on pricing context
 * @param {object} props - props passed to the component
 *
 * @returns {ReactElement} - child component with pricing context is passed in props
 */
const ContextProvider = (props) => {
  const { children, metaData, ...otherProps } = props;
  const [pricingState, setPricingState] = useState({
    pricingJson: {},
    mappedProductsId: {},
    error: null,
    isLoading: true
  });
  const isPricingEnabled = !!metaData?.hasPricing;
  const isDynamicPricingEnabled = !!metaData?.isDynamicPricingEnabled;

  useEffect(() => {
    if (isPricingEnabled && !isDynamicPricingEnabled) {
      getPricingData(metaData?.cmJsonUrl, setPricingState);
    }
    // expose nested pricing data to client window object
    global.mappedPricingUrls = metaData?.cmJsonUrl;
  }, [isPricingEnabled, isDynamicPricingEnabled]);

  const valueProps = {
    ...pricingState,
    partnerName: metaData?.partner_name,
    locale: metaData?.langAtt,
    freeGuidedSetupOfferids: metaData?.freeGuidedSetupOfferids,
    ...otherProps
  };
  let display = null;

  useMemo(() => {
    if (isPricingEnabled || isDynamicPricingEnabled) {
      display = Children.map(children, (child) => {
        return child
          ? cloneElement(child, { pricingContext: valueProps })
          : null;
      });
    } else {
      display = children;
    }
  });
  return display;
};

ContextProvider.propTypes = {
  children: node.isRequired
};

export { ContextProvider };
